<template>
  <div
    :class="{ 'visible': isOpen }"
    class="modal-wrapper"
  >
    <div class="modal">
      <div class="modal-header">
        <h2 class="is-size-5">
          Edit Division
        </h2>
        <a
          v-if="initialData.event"
          href="#"
          class="button is-danger is-outlined is-small"
          @click.prevent="removeDivision"
        ><span><Delete /></span>&nbsp;Remove</a>
      </div>
      <div class="modal-body">
        <div class="columns">
          <div class="column">
            <TextField
              :label="'Name'"
              :placeholder="'Division name'"
              :name="'eventname'"
              :initial-value="name"
              :message="nameMessage"
              :extraClass="nameMessage ? nameMessage.class : ''"
              @changedValue="saveName"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <CurrencyField
              :label="'Price'"
              :placeholder="'$10.99'"
              :name="'eventname'"
              :initial-value="price"
              :message="priceMessage"
              :extraClass="priceMessage ? priceMessage.class : ''"
              @changedValue="savePrice"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a
          href="#"
          class="button is-light"
          @click.prevent="closeModal(false)"
        >Cancel</a>
        <a
          href="#"
          :class="{ 'is-loading': submitting }"
          class="button is-warning has-text-weight-bold"
          :disabled="!isValid || submitting"
          @click.prevent="submitForm"
        >
          Save
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/inputs/TextField'
import CurrencyField from '@/components/inputs/CurrencyField'
import Delete from 'vue-material-design-icons/Delete.vue'

import inputMessages from '@/configs/inputMessages'

export default {
  name: 'EditDivision',
  components: {
    TextField,
    CurrencyField,
    Delete
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'create'
    },
    initialData: {
      type: [Object, Boolean],
      default: false
    }
  },
  data () {
    return {
      //  Values
      id: '',
      name: '',
      price: 0,
      selectedDivisions: [],
      //  Errors
      nameMessage: false,
      priceMessage: false,
      //  State
      submitting: false
    }
  },
  mounted () {
    if (this.initialData) {
      this.populateFields()
      setTimeout(() => {
        this.validateFields()
      }, 250)
    }
  },
  computed: {
    isValid () {
      return this.validateFields()
    }
  },
  methods: {
    toggleTab (value) {
      this.currentTab = value
    },
    saveName (value) {
      if (value.trim().length > 0) {
        this.name = value.trim()
        this.nameMessage = false
      } else {
        this.nameMessage = inputMessages.required
        this.name = value
      }
    },
    savePrice (value) {
      if (value > 0) {
        this.price = value
      }
    },
    validateFields () {
      let valid = false
      if (
        this.name.length > 0 &&
        this.price > 0
      ) {
        valid = true
      }
      return valid
    },
    submitForm () {
      if (this.isValid) {
        let data = {
          match: {
            id: this.id
          },
          update: {
            name: this.name,
            price: this.price
          }
        }

        this.$store
          .dispatch('admin/UPDATE_DIVISION', data)
          .then(res => {
            this.submitting = false
            this.closeModal(true)
            this.$toasted.success('Updated division')
          })
          .catch(err => {
            this.submitting = false
            this.$toasted.error('Error updating division')
            console.log(err)
          })
      }
    },
    removeDivision () {
      let data = {
        match: {
          _id: this.initialData.event
        },
        update: {
          removeDivision: this.initialData._id
        }
      }

      this.$store
        .dispatch('admin/UPDATE_EVENT', data)
        .then(res => {
          this.submitting = false
          this.closeModal(true)
          this.$toasted.success('Removed division(s) from event')
        })
        .catch(err => {
          this.submitting = false
          this.$toasted.error('Error removing division(s)')
          console.log(err)
        })
    },
    closeModal (refresh) {
      this.$emit('closeModal', refresh)
    },
    populateFields () {
      this.id = this.initialData._id
      if ('name' in this.initialData) {
        this.name = this.initialData.name
      }
      if ('price' in this.initialData) {
        this.price = this.initialData.price
      }
    }
  }
}
</script>
